const defaultRestaurant = {
    restoran_tip_ugovora: {
        paying_type: "",
        amount: "",
    },
    name: "",
    owner: "",
    paying_type: "",
    contact_person: "",
    amount: "",
    entity_type: "",
    address: "",
    phone: "",
    email: "",
    lib: "",
    pib: "",
    country: [],
    city: [],
    city_id: [],
    latitude: "",
    longitude: "",
    delivery_distance: "",
}

export {
    defaultRestaurant,
}